import MedicareBrokers from '@components/pages/medicare-brokers';

const MedicareBrokersPage = () => <MedicareBrokers />;

export default MedicareBrokersPage;
